var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-row", [
    _c(
      "div",
      {
        staticClass:
          "fixed-top d-flex align-items-center justify-content-center",
        staticStyle: { bottom: "0", "overflow-y": "auto" },
      },
      [
        _c(
          "b-col",
          { attrs: { cols: "12", md: "4" } },
          [
            _c(
              "b-card",
              {
                staticClass: "mb-2 text-left",
                attrs: { title: "Patient authentication" },
              },
              [
                _c(
                  "b-card-text",
                  [
                    _vm.message.length > 0
                      ? _c(
                          "b-alert",
                          { attrs: { show: "", variant: "danger" } },
                          [_vm._v(_vm._s(_vm.message))]
                        )
                      : _vm._e(),
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.validatePatient.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c("Date", {
                              attrs: {
                                type: "Date of Birth",
                                DOBPresent: _vm.DOBPresent,
                              },
                              on: { "custom-date": _vm.setDob },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "mt-2", attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      disabled: _vm.isDisabled,
                                      variant: "primary",
                                      "data-cy": "submit",
                                    },
                                  },
                                  [_vm._v("Submit")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }